import { render, staticRenderFns } from "./ServiceAdministrationView.vue?vue&type=template&id=2cf1c03c&scoped=true&"
import script from "./ServiceAdministrationView.vue?vue&type=script&lang=js&"
export * from "./ServiceAdministrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1c03c",
  null
  
)

export default component.exports